export const  screenIdName ={
    dashboard: 0,
    campaign : 1,
    globalCreative: 5,
    recommendedPlan: 6
}

export const typeData = {
    0:'READ_ACCESS',
    1:'WRITE_ACCESS',
    2:"FULL_ACCESS"
}

export const accessCheck = {
    READ_ACCESS:'READ_ACCESS',
    WRITE_ACCESS:'WRITE_ACCESS',
    FULL_ACCESS:"FULL_ACCESS"
}